import { Component, h, Prop } from '@stencil/core';
import { IconName } from '../../ds-icon/ds-icon';

export interface ISocialItem {
  name: string;
  rel: string;
  target: string;
  tooltip: string;
  url: string;
  iconName: IconName;
}

@Component({
  tag: 'ds-social-links',
  styleUrl: 'ds-social-links.scss'
})
export class DsSocialLinks {
  @Prop() socialLinks: Array<ISocialItem>;
  @Prop() headline: string = 'Follow';

  render() {
    return (
      <div class='ds-social-links'>
        <h4 class='ds-social-links__headline'>{this.headline}</h4>
        <ul class='ds-social-links__list'>
          {this.socialLinks &&
            this.socialLinks.map((link) => (
              <li class='ds-social-links__item'>
                <ds-social-link {...link} />
              </li>
            ))}
        </ul>
      </div>
    );
  }
}
